import { IPublishDestination } from '../../types';
import { destinationId } from '../destinationId/destinationId';

type GetDisabledReason = (destination: IPublishDestination, selectedIds: string[]) => string | undefined;

/**
 * The ids "Select all" should produce. Built incrementally from the current selection so a
 * destination disabled by an earlier pick (e.g. a sibling instance) is left out.
 */
export const getSelectAllIds = (
  publicationData: IPublishDestination[],
  selectedIds: string[],
  getDisabledReason?: GetDisabledReason,
): string[] => {
  const listedIds = new Set(publicationData.map(destinationId));
  const seed = selectedIds.filter((id) => listedIds.has(id));

  return publicationData.reduce<string[]>((accumulated, destination) => {
    const id = destinationId(destination);
    const blocked = accumulated.includes(id) || getDisabledReason?.(destination, accumulated) !== undefined;
    return blocked ? accumulated : [...accumulated, id];
  }, seed);
};
